import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type LoadingState = {
    loading: boolean;
    title?: string;
    showIcon?: boolean; 
};

const initialState : LoadingState = {
    loading: false,
    title: "Carregando aguarde...",
    showIcon: true
  }

  const handleSetLoading = ( state:  LoadingState, action: PayloadAction<boolean>)=>{
    state.loading = action.payload
  }

  const handleSetTitleLoading = ( state:  LoadingState, action: PayloadAction<string>)=>{
    state.title = action.payload
  }

  export const loadignSlice = createSlice({
    name: 'loading',
    initialState: {...initialState},
    reducers: {
      setLoading: handleSetLoading,
      setTitleLoading: handleSetTitleLoading,
      resetLoading: state => state = initialState
    }
  });

  export const {
    setLoading,
    setTitleLoading,
    resetLoading
  } = loadignSlice.actions;
  export default loadignSlice.reducer;
  